import type { LucideIcon } from 'lucide-react';
import * as React from 'react';
import { t } from '@wally-reseller/shared';
import { cn } from '../utils';
import { useUiLocale } from './locale';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex h-full select-none flex-col items-center justify-center gap-2 p-8 text-center',
        className,
      )}
    >
      <Icon className="size-10 opacity-40" strokeWidth={1} />
      <div className="text-sm font-medium">{title}</div>
      {description && <div className="max-w-xs text-xs text-muted-foreground">{description}</div>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const locale = useUiLocale();
  const message = error instanceof Error ? error.message : t(locale, 'ui.somethingWrong');
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-8 text-center">
      <div className="text-sm font-medium text-danger">{t(locale, 'ui.loadFailed')}</div>
      <div className="max-w-sm text-xs text-muted-foreground">{message}</div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 text-xs text-accent hover:underline"
        >
          {t(locale, 'ui.retry')}
        </button>
      )}
    </div>
  );
}
